module.exports = __webpack_public_path__ + "static/smartstore@2x-c76c7adc45bd3b7c318f717f0d9f8c84.png";